import { AxiosError } from "axios";
import { prepareRequestModel } from "../helpers/RequestModelUtilities";
import ManageRequestModel from "../models/ManageRequestModel";
import RequestModel from "../models/RequestModel";
import { IHttpRequestService } from "./HttpRequestService";

export interface IManageRequestService {
    GetByFileNumber(fileNumber: string): Promise<RequestModel | undefined>;
    UpdateManagedRequest(data: ManageRequestModel): Promise<RequestModel | undefined>;
}

export class ManageRequestService implements IManageRequestService {
    constructor(private httpRequestService: IHttpRequestService) {}

    public async GetByFileNumber(fileNumber: string): Promise<RequestModel | undefined> {
        try {
            const { data } = await this.httpRequestService.Get<RequestModel>(
                `/api/v1/Request/FileNumber/${encodeURIComponent(fileNumber)}`);
            return data ? prepareRequestModel(data) : undefined;
        } catch(e) {
            if((e as AxiosError).request?.status === 404) return undefined;

            this.httpRequestService.HandleError(e);
        }

        return undefined;
    }

    public async UpdateManagedRequest(data: ManageRequestModel): Promise<RequestModel | undefined> {
        try {
            const response = await this.httpRequestService.Put<RequestModel, ManageRequestModel>('/api/v1/ManageRequest/Update', data);
            return response ? prepareRequestModel(response as RequestModel) : undefined;
        } catch(e) {
            this.httpRequestService.HandleError(e);
        }

        return undefined;
    }
}
